import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { Button, Container, Grid, Link, TextField, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useContext, useState } from "react"
import { Link as RouterLink, useHistory } from "react-router-dom"
import Utilities from '../classes/Utilities'
import { Heading, PasswordField } from '../components'
import { AppContext } from '../context/AppContextProvider'

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}))

export default function ForgotPassword(props) {
    const { paths, forgotPasswordCode, showMessage, showError, socket } = useContext(AppContext)
    const history = useHistory()
    const [waiting, setWaiting] = useState(false)
    const [complete, setComplete] = useState(false)
    const classes = useStyles()

    async function handleRequestReset(event) {
        event.preventDefault()

        setWaiting(true)

        try {
            const values = Utilities.getFormValues(event.target)

            const response = await socket.send('forgotPassword', {
                step: 'requestReset',
                email: values.email,
            })

            showMessage(response, { variant: 'success' })
            setComplete(true)

        } catch (err) {
            showError(err)
            setWaiting(false)
        }
    }

    async function handlePasswordReset(event) {
        event.preventDefault()

        setWaiting(true)

        try {
            const values = Utilities.getFormValues(event.target)

            const response = await socket.send('forgotPassword', {
                step: 'validate',
                user: forgotPasswordCode.user,
                code: forgotPasswordCode.code,
                password: values.password,
            })

            showMessage(response, { variant: 'success' })
            setComplete(true)

            props.onPasswordReset()

        } catch (err) {
            setWaiting(false)
            showError(err)
        }
    }

    return (
        <Container maxWidth="xs">
            <Heading icon={<LockOutlinedIcon />}>
                Reset Password
            </Heading>
            {!forgotPasswordCode && !complete &&
                <form className={classes.form} onSubmit={handleRequestReset}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                id="email"
                                name="email"
                                label="Email Address"
                                variant="outlined"
                                type="email"
                                autoComplete="email"
                                required
                                fullWidth
                                disabled={waiting}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        className={classes.submit}
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={waiting}
                    >
                        Request password reset
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        fullWidth
                        disabled={waiting}
                        onClick={() => { history.push(paths.root) }}
                    >
                        Cancel
                    </Button>
                </form>
            }
            {!forgotPasswordCode && complete &&
                <form className={classes.form}>
                    <Grid container spacing={2}>
                        <Typography>
                            An password reset email has been sent to your email address. Please check your inbox.
                        </Typography>
                    </Grid>
                    <p></p>
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link component={RouterLink} to={paths.root} variant="body2" underline="hover">Back to Login</Link>
                        </Grid>
                    </Grid>
                </form>
            }
            {forgotPasswordCode && !complete &&
                <form className={classes.form} onSubmit={handlePasswordReset}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <PasswordField
                                id="password"
                                name="password"
                                label="New Password"
                                variant="outlined"
                                autoComplete="off"
                                required
                                fullWidth
                                disabled={waiting}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        className={classes.submit}
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={waiting}
                    >
                        Change Password
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        fullWidth
                        disabled={waiting}
                        onClick={() => { history.push(paths.root) }}
                    >
                        Cancel
                    </Button>
                </form>
            }
            {forgotPasswordCode && complete &&
                <form className={classes.form}>
                    <Grid container spacing={2}>
                        <Typography>
                            Your password has been updated. You may now login using it.
                        </Typography>
                    </Grid>
                    <p></p>
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link component={RouterLink} to={paths.root} variant="body2" underline="hover">Back to Login</Link>
                        </Grid>
                    </Grid>
                </form>
            }
        </Container>
    )
}
